"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showModal = showModal;
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
let idCounter = 0;
/**
 * Store all requested modals.
 */
const globalModalQueue = mobx_1.observable.array([]);
class GlobalModal extends react_1.default.Component {
    modalPortal = document.createElement('div');
    bodyScrollReactionDisposer = (0, mobx_1.reaction)(() => this.currentModalConfig, (modalConfig) => {
        const body = document.body;
        if (!modalConfig) {
            body.style.overflow = '';
        }
        else {
            body.style.overflow = 'hidden';
        }
    });
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            currentModalConfig: mobx_1.computed,
        });
    }
    get currentModalConfig() {
        if (globalModalQueue.length) {
            return globalModalQueue[0];
        }
        return undefined;
    }
    componentDidMount() {
        const portalsContainer = document.getElementById(__APP__.PORTAL_ELEMENT_ID);
        if (portalsContainer) {
            portalsContainer.append(this.modalPortal);
        }
        document.addEventListener('keyup', this.onDocumentKeyup);
    }
    componentWillUnmount() {
        const portalsContainer = document.getElementById(__APP__.PORTAL_ELEMENT_ID);
        if (portalsContainer) {
            portalsContainer.removeChild(this.modalPortal);
        }
        this.bodyScrollReactionDisposer();
        document.removeEventListener('keyup', this.onDocumentKeyup);
    }
    render() {
        if (!this.currentModalConfig) {
            return null;
        }
        const { component, id, props = {}, isNotCancelable } = this.currentModalConfig;
        const classDialog = (0, classnames_1.default)('modal-dialog', 'znd-modal__dialog', 'modal-dialog-centered', this.currentModalConfig.size ?? 'modal-lg', { 'modal-dialog-scrollable': !this.currentModalConfig.dialogNotScrollable });
        const classModal = (0, classnames_1.default)('modal znd-modal fade show d-block', {
            'znd-modal__scrollable': this.currentModalConfig.mainScrollable,
            'znd-modal--as-desktop': this.currentModalConfig.avoidMobileStyleAndRenderAlwaysAsDesktop,
        });
        return react_dom_1.default.createPortal(react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { key: id, className: classModal, tabIndex: -1, role: "dialog" },
                react_1.default.createElement("div", { className: classDialog },
                    react_1.default.createElement("div", { className: "modal-content znd-modal__content", onClick: (event) => {
                            event.stopPropagation();
                        } }, react_1.default.createElement(component, {
                        ...props,
                        isNotCancelable,
                        onCancel: this.onCancel,
                        onDone: this.onDone,
                    })))),
            react_1.default.createElement("div", { className: "modal-backdrop fade show" })), this.modalPortal);
    }
    onCancel(reason) {
        if (true === this.currentModalConfig?.isNotCancelable) {
            return;
        }
        this.currentModalConfig?.cancelCallback(reason);
    }
    onDone(result) {
        this.currentModalConfig?.doneCallback(result);
    }
    onDocumentKeyup(event) {
        if (event.key === 'Escape' && this.currentModalConfig) {
            this.onCancel();
        }
    }
}
__decorate([
    bind_decorator_1.default
], GlobalModal.prototype, "onCancel", null);
__decorate([
    bind_decorator_1.default
], GlobalModal.prototype, "onDone", null);
__decorate([
    bind_decorator_1.default
], GlobalModal.prototype, "onDocumentKeyup", null);
exports.default = (0, mobx_react_1.observer)(GlobalModal);
function showModal(config) {
    return new Promise((0, mobx_1.action)((resolve, reject) => {
        const id = idCounter++;
        const close = (0, mobx_1.action)(() => {
            const index = globalModalQueue.findIndex((item) => item.id === id);
            globalModalQueue.splice(index, 1);
        });
        globalModalQueue.push({
            ...config,
            // @ts-expect-error Workaround for "Class constructor cannot be invoked without 'new' until a solution is found".
            component: (props) => react_1.default.createElement(config.component, { ...props }),
            id,
            isVisible: true,
            // @ts-expect-error - Because generics do not match with `{}` as defined in the globalModalQueue.
            doneCallback(internalResult) {
                resolve(internalResult);
                close();
            },
            // @ts-expect-error - Because generics do not match with `{}` as defined in the globalModalQueue.
            cancelCallback(internalError) {
                reject(internalError);
                close();
            },
        });
    }));
}
